import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "ageContainer",
    "ageField",
    "sexContainer",
    "maleData",
    "femaleData",
    "diverseData",
    "totalData",
  ];

  connect() {
    this.updateAgeFieldChecked();
    this.updateSexField();
    this.setupAgeTable();
    this.ageContainerTarget
      .querySelectorAll(".checkbox input[type='checkbox']")
      .forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          this.updateAgeFieldChecked();
        });
      });
    this.displayableAges = [
      "14-24_age",
      "25-34_age",
      "34-44_age",
      "45-54_age",
      "55-64_age",
      "65_age",
    ];
  }

  selectAllAge() {
    const checkboxes = this.ageContainerTarget.querySelectorAll(
      ".checkbox input[type='checkbox']"
    );
    const checkStatus = this.ageFieldTarget.checked;

    checkboxes.forEach((checkbox) => {
      checkbox.checked = checkStatus;
    });
  }

  updateAgeFieldChecked() {
    const checkboxes = Array.from(
      this.ageContainerTarget.querySelectorAll(
        ".checkbox input[type='checkbox']"
      )
    );
    checkboxes.shift();

    let allChecked = Array.from(checkboxes).every(
      (checkbox) => checkbox.checked
    );

    this.ageFieldTarget.checked = allChecked;
  }

  setupGender({ params }) {
    switch (params.type) {
      case "man":
        this.showTarget(this.maleDataTarget);
        this.hideTargets([
          this.femaleDataTarget,
          this.diverseDataTarget,
          this.totalDataTarget,
        ]);
        break;
      case "woman":
        this.showTarget(this.femaleDataTarget);
        this.hideTargets([
          this.maleDataTarget,
          this.diverseDataTarget,
          this.totalDataTarget,
        ]);
        break;
      case "diverse":
        this.showTarget(this.diverseDataTarget);
        this.hideTargets([
          this.maleDataTarget,
          this.femaleDataTarget,
          this.totalDataTarget,
        ]);
        break;
      default:
        this.showTargets([
          this.maleDataTarget,
          this.femaleDataTarget,
          this.diverseDataTarget,
          this.totalDataTarget,
        ]);
    }
  }

  showTarget(target) {
    target.classList.remove("hidden");
  }

  hideTargets(targets) {
    targets.forEach((target) => {
      target.classList.add("hidden");
    });
  }

  showTargets(targets) {
    targets.forEach((target) => {
      target.classList.remove("hidden");
    });
  }

  setupAge({ params }) {
    window.dispatchEvent(
      new CustomEvent("filterAge", { detail: { age: params.age } })
    );

    this.setupAgeTable();
  }

  updateSexField() {
    let checkedRadio;

    const radioButtons =
      this.sexContainerTarget.querySelectorAll("input[type='radio'");

    for (let i = 0; i < radioButtons.length; i++) {
      if (radioButtons[i].checked) {
        checkedRadio = radioButtons[i];
        break;
      }
    }
    let params = {
      type: checkedRadio.getAttribute("data-retargeting-type-param"),
    };

    this.setupGender({ params });
  }

  setupAgeTable() {
    let ageElements = document.querySelectorAll("[data-range]");

    const checkboxes = Array.from(
      this.ageContainerTarget.querySelectorAll(
        ".checkbox input[type='checkbox']:checked"
      )
    );
    console.log(checkboxes.length);
    if (checkboxes.length === 7) {
      checkboxes.shift();
    }
    if (checkboxes.length === 0) {
      this.displayableAges = [
        "14-24_age",
        "25-34_age",
        "34-44_age",
        "45-54_age",
        "55-64_age",
        "65_age",
      ];
    } else {
      this.displayableAges = checkboxes.map(
        (element) => `${element.value}_age`
      );
    }

    ageElements.forEach((element) => {
      if (this.displayableAges.includes(element.getAttribute("data-range"))) {
        element.classList.remove("hidden");
      } else element.classList.add("hidden");
    });
  }
}
